export enum ReferralAdditionalInfo {
  AddDomainPurchaseIntent = 'add-domain-purchase-intent-dropshipping',
  AddDomainConnectIntent = 'add-domain-connect-intent-dropshipping',
}

export const SUNRISE_FAMILY_LIGHT_ID = '217fdefb-918b-46cb-8cfa-c010cbff46f9';
const STUDIO_FAMILY_LIGHT_ID = 'e8644d34-6998-4a61-8296-9a45379e20f2';

export const LIGHT_FAMILY_IDS = [
  SUNRISE_FAMILY_LIGHT_ID,
  STUDIO_FAMILY_LIGHT_ID,
];

export const WIXEL_LIGHT_COUPON_PREFIX = "1yearfreelight";